import { render, staticRenderFns } from "./Optin.vue?vue&type=template&id=7d495564&"
import script from "./Optin.vue?vue&type=script&lang=js&"
export * from "./Optin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d495564')) {
      api.createRecord('7d495564', component.options)
    } else {
      api.reload('7d495564', component.options)
    }
    module.hot.accept("./Optin.vue?vue&type=template&id=7d495564&", function () {
      api.rerender('7d495564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Optin.vue"
export default component.exports